module.exports = __webpack_public_path__ + "img/cardAccident.df764298.png";